import { cn } from './cn';

const variants = {
  primary: 'bg-brand-400 text-on-brand hover:bg-brand-500 disabled:opacity-50',
  secondary:
    'border border-line-strong bg-surface text-fg-subtle hover:bg-surface-2 hover:text-fg disabled:opacity-50',
  ghost: 'text-fg-muted hover:bg-sidebar-hover hover:text-fg',
  danger: 'bg-gray-100 text-fg hover:bg-gray-200',
} as const;

const sizes = {
  sm: 'h-8 px-3 text-sm gap-1.5',
  md: 'h-10 px-4 text-sm gap-2',
  lg: 'h-12 px-6 text-base gap-2',
} as const;

export type ButtonVariant = keyof typeof variants;
export type ButtonSize = keyof typeof sizes;

export function buttonClass(variant: ButtonVariant = 'primary', size: ButtonSize = 'md') {
  return cn(
    'inline-flex shrink-0 items-center justify-center rounded-lg font-medium transition-[background-color,color,transform] active:scale-[0.98] disabled:cursor-not-allowed disabled:active:scale-100',
    variants[variant],
    sizes[size],
  );
}
